<script lang="ts">
    import { scale } from 'svelte/transition'
    import dayjs from 'dayjs'
    import { createEventDispatcher, tick } from 'svelte'
    import Fa from 'svelte-fa'
    import type { CreateEntryDto } from '../../../modules/financialApi/entries/dto/create-entry.dto'
    import type { Category } from '../../../modules/financialApi/categories/category'
    import { EntryTypeEnum } from '../../../modules/financialApi/entries/entry.enum'
    import { faSave, faExchangeAlt, faRobot } from '@fortawesome/free-solid-svg-icons'
    const dispatch = createEventDispatcher()

    export let entry: CreateEntryDto
    export let categories: Category[] = []
    export let position: number
    export let total: number
    export let accrualMonth: number
    export let accrualYear: number

    let accrualPeriod: 'monthly' | 'yearly' = 'monthly'
    let accrual: string = null

    let editAccrual = true
    function changeAccrual() {
        editAccrual = true
    }

    let editDescription = false
    function changeDescription() {
        editDescription = true
    }

    if (window.configs.financialShowAccrual) {
        if (accrualMonth) {
            accrualPeriod = 'monthly'
            accrual = accrualYear + '-' + accrualMonth.toString().padStart(2, '0')
            editAccrual = false
        } else if (accrualYear) {
            accrualPeriod = 'yearly'
            accrual = accrualYear.toString()
            editAccrual = false
        }
    }

    const _position: number = position

    let heightClosed = window.configs.financialShowAccrual ? '152' : '112'

    function calcSize() {
        const limit = window.screen.height > 768 ? 30 : 20
        return categories.length < limit ? categories.length : limit
    }

    let size = calcSize()

    let style = ''

    function categoryChanged() {
        style = 'background-color:#1e544b'
        dispatch('change', entry)
        setTimeout(() => {
            style = ''
        }, 2000)
    }

    function removeCategory() {
        entry.categoryId = null
        entry = entry
    }

    function goClassification(el) {
        dispatch('classification', el)
    }

    function onPeriodChange() {
        accrual = null
        accrualYear = null
        accrualMonth = null
        onAccrualChange()
    }

    function onAccrualChange() {
        if (window.configs.financialShowAccrual) {
            if (accrual) {
                console.log('accrual', accrual)
                if (accrualPeriod === 'monthly') {
                    accrual = accrual.toString()
                    accrualYear = parseInt(accrual.split('-')[0])
                    accrualMonth = parseInt(accrual.split('-')[1])
                } else {
                    accrualYear = parseInt(accrual)
                    accrualMonth = null
                }
                editAccrual = false
            }
            if (!accrual) {
                accrualYear = null
                accrualMonth = null
            }
            console.log('accrual-changed', accrualYear, accrualMonth)
            dispatch('change', entry)
        }
    }

    function goDescriptionChange() {
        dispatch('change', entry)
        setTimeout(() => {
            editDescription = false
        }, 150)
    }

    async function lastMonth() {
        accrualPeriod === 'monthly'
        await tick()
        const date = new Date(entry.paymentAt)
        accrual = dayjs(date).subtract(1, 'month').format('YYYY-MM')
        onAccrualChange()
    }
    async function currentMonth() {
        accrualPeriod === 'monthly'
        await tick()
        const date = new Date(entry.paymentAt)
        accrual = dayjs(date).format('YYYY-MM')
        onAccrualChange()
    }
    async function currentYear() {
        accrualPeriod === 'yearly'
        await tick()
        const date = new Date(entry.paymentAt)
        accrual = date.getFullYear().toString()
        onAccrualChange()
    }
</script>

{#if entry}
    <div
        class="financial-import-item-outer"
        class:financial-import-items-imported={entry.categoryId}
        transition:scale
        style="max-height:{entry.categoryId ? heightClosed + 'px' : '800px'};"
    >
        <div class="financial-import-item" {style}>
            <div class="-lines">
                <div class="-line">
                    <div class="-number">
                        <span class="title-badge">Registro</span>
                        <span>
                            {_position} de {total}
                        </span>
                    </div>
                    <div class="-date">
                        <span class="title-badge">Data</span>
                        <span>
                            {dayjs(entry.paymentAt).format('DD/MM/YY')}
                        </span>
                    </div>
                    <div class="-amount">
                        <span class="title-badge">Valor</span>
                        <span>
                            {(entry.type === EntryTypeEnum.debit ? '-' : '') + entry.value.toFixed(2)}
                        </span>
                    </div>
                </div>

                <div class="-line">
                    {#if editDescription}
                        <div class="input-group input-group-sm">
                            <label for="" class="input-group-text">Descrição</label>
                            <input type="text" bind:value={entry.description} class="form-control" />
                            <button class="btn btn-sm btn-secondary" on:click={goDescriptionChange}><Fa icon={faSave}></Fa></button>
                        </div>
                    {:else}
                        <div class="-description">
                            <span class="title-badge">Descrição</span>
                            <span>
                                {entry.description}
                            </span>
                        </div>
                        <button class="btn btn-sm btn-secondary" on:click={changeDescription}><Fa icon={faExchangeAlt}></Fa> Alterar</button>
                    {/if}
                </div>

                {#if window.configs.financialShowAccrual}
                    <div class="-line">
                        {#if !editAccrual}
                            <div class="-accrual">
                                <span class="title-badge">Competência</span>
                                <span>{entry.accrualMonth ? entry.accrualMonth + '/' : ''}{entry.accrualYear || ''}</span>
                            </div>
                            <button class="btn btn-sm btn-secondary" on:click={changeAccrual}><Fa icon={faExchangeAlt}></Fa> Alterar</button>
                        {:else}
                            <div class="-description">
                                <div class="input-group input-group-sm me-2">
                                    <label for="" class="input-group-text">Tipo de competência</label>
                                    <select bind:value={accrualPeriod} class="form-select" on:change={onPeriodChange}>
                                        <option value="monthly">Mensal</option>
                                        <option value="yearly">Anual</option>
                                    </select>
                                </div>
                                {#if accrualPeriod === 'monthly'}
                                    <div class="input-group input-group-sm">
                                        <label for="" class="input-group-text">Mês de competência</label>
                                        <input type="month" bind:value={accrual} class="form-control" on:change={onAccrualChange} />
                                    </div>
                                {:else}
                                    <div class="input-group input-group-sm me-2">
                                        <label for="" class="input-group-text">Ano de competência</label>
                                        <input type="number" bind:value={accrual} class="form-control" on:change={onAccrualChange} />
                                    </div>
                                {/if}
                                <div class="-description-shortcuts">
                                    {#if accrualPeriod === 'monthly'}
                                        <div on:click={lastMonth} class="btn btn-secondary btn-sm ms-2 me-1">mês anterior ao pagamento</div>
                                        <div on:click={currentMonth} class="btn btn-secondary btn-sm me-1">mês do pagamento</div>
                                    {:else}
                                        <div on:click={currentYear} class="btn btn-secondary btn-sm">ano do pagamento</div>
                                    {/if}
                                </div>
                            </div>
                        {/if}
                    </div>
                {/if}

                <div class="-line fix-min-height">
                    {#if entry.categoryId}
                        <div class="-category-closed">
                            <span class="title-badge">Categoria</span>
                            <span>
                                {categories.find((el) => el.categoryId === entry.categoryId)?.label || '[selecione uma categoria]'}
                            </span>
                            {#if entry.classificationId}
                                <button on:click={() => goClassification(entry)} class="btn btn-sm btn-primary"
                                    ><Fa icon={faRobot}></Fa> Classificado automaticamente</button
                                >
                            {:else}
                                <button on:click={() => goClassification(entry)} title="Classificação automática" class="btn btn-sm btn-secondary"
                                    ><Fa icon={faRobot}></Fa> Criar classificação</button
                                >
                            {/if}

                            {#if entry.categoryId}
                                <button class="btn btn-sm btn-secondary" on:click={removeCategory}><Fa icon={faExchangeAlt}></Fa> Alterar</button>
                            {/if}
                        </div>
                    {:else}
                        <div>Selecione uma categoria:</div>
                    {/if}
                </div>

                <div class="-category">
                    <select class="form-select form-select-sm scroll-dark" {size} bind:value={entry.categoryId} on:change={categoryChanged}>
                        {#each categories as category}
                            <option value={category.categoryId}>{category.label}</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .financial-import-item-outer {
        display: flex;
        margin-top: 8px;
        margin-bottom: 24px;
        width: 100%;
        transition: max-height 0.3s;
    }

    .financial-import-item select,
    .financial-import-item select:focus {
        border: 1px solid #00000000 !important;
        box-shadow: none !important;
        background-color: #99999910;
    }

    .financial-import-item {
        flex: 1 1 0px;
        background-color: #99999920;
        border-radius: 8px;
        overflow: hidden;
        transition: background-color 2s;
    }

    .financial-import-items-imported .financial-import-item {
        background-color: #1e433a99;
    }

    .financial-import-item .-lines {
        padding: 8px;
    }
    .financial-import-item .-line {
        display: flex;
        margin-bottom: 8px;
    }
    .financial-import-item .-line > div {
        min-width: 116px;
        flex-shrink: 0;
        margin-right: 12px;
    }
    .financial-import-item .-line > * {
        display: flex;
        align-items: center;
    }
    .financial-import-item .-line .-category-closed {
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .financial-import-item .-line .-category-closed button,
    .financial-import-item .-line .-accrual button {
        margin-left: 6px;
        padding-top: 2px;
        padding-bottom: 2px;
    }

    .financial-import-item .-category .title-badge {
        margin-bottom: 8px;
    }

    .financial-import-item .fix-min-height {
        min-height: 27px;
    }

    .financial-import-item .-line .-description {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>
